import React from 'react';
import clsx from 'clsx';
import { createUseStyles } from 'react-jss';

import { useSeeMore } from '../hooks/useSeeMore';

const useStyles = createUseStyles((theme) => ({
  seeMoreText: {},
  seeMore: {
    fontWeight: 500,
    fontStyle: 'italic',
    marginLeft: 12,
  },
  action: {
    composes: 'flexRow spaceBetween',
  },
  text: {
    padding: 0,
    marginTop: theme.spacing(1),
    margin: 0,
  },
  label: {
    fontWeight: 600,
  },
}));

const SeeMoreText = ({ className, text, label, action }) => {
  const classes = useStyles();

  const { seeMore, fullText, extractedText, isFullText, isMore } = useSeeMore(text);

  return (
    <div className={clsx(classes.seeMoreText, className)}>
      {label && (
        <div className={clsx(classes.label, action ? classes.action: undefined)}>
          {label}
          {action}
        </div>
      )}
      <p className={classes.text}>
        {isFullText ? fullText : extractedText}
        {isMore &&  <span className={classes.seeMore} onClick={seeMore}>Voir {!isFullText ? 'plus': 'moins'}</span>}
      </p>
    </div>

  );
}

export default SeeMoreText;